<template>
    <div class="border-l-4 p-4" :class="[borderColor, bgColor]" v-if="message">
        <div class="flex">
            <div class="flex-shrink-0">
                <svg
                    class="h-5 w-5"
                    :class="iconColor"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                >
                    <path clip-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" fill-rule="evenodd" />
                </svg>
            </div>
            <div class="ml-3">
                <p class="text-sm leading-5" :class="textColor">
                    {{ message }}
                </p>
            </div>
            <div class="ml-auto pl-3" v-if="dismissable">
                <div class="-mx-1.5 -my-1.5">
                    <button
                        aria-label="Dismiss"
                        class="inline-flex rounded-md p-1.5 focus:outline-none transition ease-in-out duration-150"
                        :class="[dismissColor, dismissHoverColor]"
                        @click="dismiss"
                    >
                        <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                            <path clip-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" fill-rule="evenodd" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            message: {
                type: String,
                default: '',
                required: true,
            },
            type: {
                type: String,
                default: 'warning',
                validator: value => ['error', 'danger', 'warning', 'info', 'success'].includes(value),
            },
            dismissable: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            dismissColor() {
                switch (this.type) {
                    case 'warning':
                        return 'text-yellow-500';
                    case 'info':
                        return 'text-blue-500';
                    case 'success':
                        return 'text-green-500';
                    default:
                        return 'text-red-500';
                }
            },

            dismissHoverColor() {
                switch (this.type) {
                    case 'warning':
                        return 'hover:bg-yellow-100 focus:bg-yellow-100 ';
                    case 'info':
                        return 'hover:bg-blue-100 focus:bg-blue-100 ';
                    case 'success':
                        return 'hover:bg-green-100 focus:bg-green-100 ';
                    default:
                        return 'hover:bg-red-100 focus:bg-red-100 ';
                }
            },

            borderColor() {
                switch (this.type) {
                    case 'warning':
                        return 'border-yellow-400';
                    case 'info':
                        return 'border-blue-400';
                    case 'success':
                        return 'border-green-400';
                    default:
                        return 'border-red-400';
                }
            },

            bgColor() {
                switch (this.type) {
                    case 'warning':
                        return 'bg-yellow-50';
                    case 'info':
                        return 'bg-blue-50';
                    case 'success':
                        return 'bg-green-50';
                    default:
                        return 'bg-red-50';
                }
            },

            iconColor() {
                switch (this.type) {
                    case 'warning':
                        return 'text-yellow-400';
                    case 'info':
                        return 'text-blue-400';
                    case 'success':
                        return 'text-green-400';
                    default:
                        return 'text-red-400';
                }
            },

            textColor() {
                switch (this.type) {
                    case 'warning':
                        return 'text-yellow-700';
                    case 'info':
                        return 'text-blue-700';
                    case 'success':
                        return 'text-green-700';
                    default:
                        return 'text-red-700';
                }
            },
        },

        methods: {
            dismiss() {
                this.$emit('update:message', '');
            },
        },
    };
</script>
